// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    AmbulanceTransportReasonCodeType,
    AmbulanceTransportReasonCodeTypeFromJSON,
    AmbulanceTransportReasonCodeTypeToJSON,
    ProfessionalTemplateAmbulanceCertification,
    ProfessionalTemplateAmbulanceCertificationFromJSON,
    ProfessionalTemplateAmbulanceCertificationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfessionalTemplateAmbulanceInformation
 */
export interface ProfessionalTemplateAmbulanceInformation {
    /**
     * Weight in pounds of the patient at time of transport
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12PatientWeight?: number;
    /**
     * 
     * OpenAPI data type: {AmbulanceTransportReasonCodeType}
     * @type {AmbulanceTransportReasonCodeType}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12TransportReasonCode?: AmbulanceTransportReasonCodeType;
    /**
     * Distance traveled in miles
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12Distance?: number;
    /**
     * Required when the ambulance service is for a round trip.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12RoundTripNarrative?: string;
    /**
     * Required when needed to justify the usage of stretcher.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12StretcherNarrative?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProfessionalTemplateAmbulanceCertification>}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12Certifications?: Array<ProfessionalTemplateAmbulanceCertification>;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12PickUpLocation?: Address;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12DropOffLocation?: Address;
    /**
     * Required when more than one patient is transported in the same vehicle for ambulance or non-emergency transportation services.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProfessionalTemplateAmbulanceInformation
     */
    x12PatientCount?: number;
}

export function ProfessionalTemplateAmbulanceInformationFromJSON(json: any): ProfessionalTemplateAmbulanceInformation {
    return {
            'x12PatientWeight': !exists(json, 'x12PatientWeight') ? undefined : json['x12PatientWeight'],
            'x12TransportReasonCode': !exists(json, 'x12TransportReasonCode') ? undefined : AmbulanceTransportReasonCodeTypeFromJSON(json['x12TransportReasonCode']),
            'x12Distance': !exists(json, 'x12Distance') ? undefined : json['x12Distance'],
            'x12RoundTripNarrative': !exists(json, 'x12RoundTripNarrative') ? undefined : json['x12RoundTripNarrative'],
            'x12StretcherNarrative': !exists(json, 'x12StretcherNarrative') ? undefined : json['x12StretcherNarrative'],
            'x12Certifications': !exists(json, 'x12Certifications') ? undefined : (json['x12Certifications'] as Array<any>).map(ProfessionalTemplateAmbulanceCertificationFromJSON),
            'x12PickUpLocation': !exists(json, 'x12PickUpLocation') ? undefined : AddressFromJSON(json['x12PickUpLocation']),
            'x12DropOffLocation': !exists(json, 'x12DropOffLocation') ? undefined : AddressFromJSON(json['x12DropOffLocation']),
            'x12PatientCount': !exists(json, 'x12PatientCount') ? undefined : json['x12PatientCount'],
    };

}

export function ProfessionalTemplateAmbulanceInformationToForm(value?: ProfessionalTemplateAmbulanceInformation): any {
    let jsonVal = ProfessionalTemplateAmbulanceInformationToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProfessionalTemplateAmbulanceInformationToJSON(value?: ProfessionalTemplateAmbulanceInformation): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'x12PatientWeight': cleanupBlankValuesForBackend(value.x12PatientWeight),
            'x12TransportReasonCode': AmbulanceTransportReasonCodeTypeToJSON(value.x12TransportReasonCode),
            'x12Distance': cleanupBlankValuesForBackend(value.x12Distance),
            'x12RoundTripNarrative': cleanupBlankValuesForBackend(value.x12RoundTripNarrative),
            'x12StretcherNarrative': cleanupBlankValuesForBackend(value.x12StretcherNarrative),
            'x12Certifications': (value.x12Certifications === undefined || value.x12Certifications === null) ? undefined : (value.x12Certifications as Array<any>).map(ProfessionalTemplateAmbulanceCertificationToJSON),
            'x12PickUpLocation': AddressToJSON(value.x12PickUpLocation),
            'x12DropOffLocation': AddressToJSON(value.x12DropOffLocation),
            'x12PatientCount': cleanupBlankValuesForBackend(value.x12PatientCount),
    };
}


